export const IMAGE_PRESETS = {
    // 1:1 Square cropped thumbnail (Lists, Tables, Small previews)
    THUMBNAIL_SQUARE: {
        width: 300,
        height: 300,
        fit: 'cover',
        quality: 50,
    },

    // Standard Product Card (Grid views, Search results)
    PRODUCT_CARD: {
        width: 450,
        height: 600,
        fit: 'cover',
        quality: 70,
    },

    // High-Res Detailed View (Product detail main image / Zoom view)
    PRODUCT_DETAIL: {
        width: 1000,
        height: 1000,
        fit: 'contain', // keeps full aspect ratio without cropping borders
        quality: 85,
    },

    // Hero / Promotional Banners (Wide landscape)
    HERO_BANNER: {
        width: 1200,
        height: 400,
        fit: 'cover',
        quality: 80,
    },

    // User Avatar / Small Icons
    AVATAR: {
        width: 100,
        height: 100,
        fit: 'cover',
        quality: 60,
    },

    // Micro Preview / Low-Quality Image Placeholder (LQIP for progressive loading)
    BLUR_PLACEHOLDER: {
        width: 20,
        height: 20,
        fit: 'cover',
        quality: 10,
    },
};